import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import NotificationManager from '@adsk/bim360-matrix-react-notification-manager';
import {resetNotification} from '../../app/actions';
import {getNotification} from '../../app/selectors';
import {connect} from '../../app/connect';
import {childrenType} from '../../constants/proptype-validation';

const useAlignNotificationsWithStore = ({notification, dispatch}) => {
  const notificationManagerRef = useRef();
  useEffect(() => {
    if (notification) {
      notificationManagerRef.current.addNotification({
        level: notification.level,
        autoDismiss: notification.autoDismiss, //if we don't pass autoDismiss the default is 6 seconds
        type: notification.type,
        message: notification.message,
        asyncOperation: notification.asyncOperation,
        closeButtonRenderer: notification.closeButtonTooltipText
          ? ({getCloseButton, asyncOperationResult}) => {
            if (asyncOperationResult && asyncOperationResult.success) {
              return getCloseButton();
            } else {
              return <Tooltip content={notification.closeButtonTooltipText}>{getCloseButton()}</Tooltip>;
            }
          }
          : undefined
      });
      dispatch(resetNotification());
    }
  }, [dispatch, notification]);
  return notificationManagerRef;
};

const NotificationManagerWrapper = ({children, notification, dispatch}) => {
  const ref = useAlignNotificationsWithStore({notification, dispatch});
  return (
    <>
      {children}
      <NotificationManager ref={ref} />
    </>
  );
};

NotificationManagerWrapper.displayName = 'NotificationManagerWrapper';

NotificationManagerWrapper.propTypes = {
  children: childrenType.isRequired,
  notification: PropTypes.object,
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  notification: getNotification(state)
});

export default connect(mapStateToProps)(NotificationManagerWrapper);
